import React from 'react';
import { formatStringDate } from '../../../helpers/dateFormatter';

function InfoComponent(props) {
    return <div className="row">
        <div className="col-md-12">
            <div className="card card-default">
                <div className="card-body textAlignLeft">
                    <div className="row">
                        {props.apartment.type &&
                            <div className="col-md-3 panelRowPadding">
                                <label>Type</label><br />
                                {props.apartment.type}
                            </div>}
                        {props.apartment.sqm &&
                            <div className="col-md-3 panelRowPadding">
                                <label>m<sup>2</sup></label><br />
                                {props.apartment.sqm}
                            </div>}
                        {props.apartment.garden &&
                            <div className="col-md-3 panelRowPadding">
                                <label>Have?</label><br />
                                <span className={props.apartment.garden ? 'bi bi-check-circle' : 'bi bi-circle-fill'}>&nbsp;</span>
                            </div>}
                        {props.apartment.balcony &&
                            <div className="col-md-3 panelRowPadding">
                                <label>Altan?</label><br />
                                <span className={props.apartment.balcony ? 'bi bi-check-circle' : 'bi bi-circle-fill'}>&nbsp;</span>
                            </div>}
                        {props.apartment.basement &&
                            <div className="col-md-3 panelRowPadding">
                                <label>Kælderrum</label><br />
                                {props.apartment.basement}
                            </div>}
                        {props.apartment.attic &&
                            <div className="col-md-3 panelRowPadding">
                                <label>Loftrum</label><br />
                                {props.apartment.attic}
                            </div>}
                        {props.apartment.apartmentFee &&
                            <div className="col-md-3 panelRowPadding">
                                <label>Boligafgift</label><br />
                                {props.apartment.apartmentFee}
                            </div>}
                        {props.apartment.acontoheat &&
                            <div className="col-md-3 panelRowPadding">
                                <label>Aconto varme</label><br />
                                {props.apartment.acontoheat}
                            </div>}
                        {props.apartment.heathose &&
                            <div className="col-md-3 panelRowPadding">
                                <label>Varmehaner</label><br />
                                {props.apartment.heathose}
                            </div>}
                        {props.apartment.vinduefang !== null &&
                            <div className="col-md-3 panelRowPadding">
                                <label>Vinduefang</label><br />
                                {props.apartment.vinduefang}
                            </div>}
                        {props.apartment.andelskroner &&
                            <div className="col-md-3 panelRowPadding">
                                <label>Andelskroner</label><br />
                                {props.apartment.andelskroner}
                            </div>}
                        {props.apartment.price &&
                            <div className="col-md-3 panelRowPadding">
                                <label>Max udbuds salgspris</label><br />
                                {props.apartment.price}
                            </div>}

                        {props.apartment.andelsbevisDate &&
                            <div className="col-md-3 panelRowPadding">
                                <label>Andelsbevis sidste print dato</label><br />
                                {formatStringDate(props.apartment.andelsbevisDate)}
                            </div>}

                        {props.apartment.company &&
                            <div className="col-md-3 panelRowPadding">
                                <label>Erhverv?</label><br />
                                <span className={props.apartment.company ? 'bi bi-check-circle' : 'bi bi-circle-fill'}>&nbsp;</span>
                            </div>}
                        {props.apartment.note &&
                            <div className="col-md-6 panelRowPadding">
                                <label>Note</label><br />
                                {props.apartment.note}
                            </div>}
                    </div>
                </div>
            </div>
        </div>
    </div>;
}
export default InfoComponent;